"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      search: '',
      // 顶部搜索框form数据
      formInline: {
        alipay_id: '',
        userphone: '',
        orderNo: '',
        username: '',
        start_time: '',
        end_time: '',
        g_date: '0',
        status: '0',
        three_order: '',
        is_jd: -1
      },
      action: '/api/safe/posts/',
      complain_picture: [],
      complain_text: '',
      complain_order_id: 0,
      datenum: '',
      // 订单列表数据
      dataList: {
        count: 0
      },
      listLoading: false,
      is_show_complain: false,
      listQuery: {
        page: 1,
        page_size: 10
      }
    };
  },
  created: function created() {
    if (this.$route.query.page) {
      this.listQuery.page = parseInt(this.$route.query.page);
    }
    this.getOrderList();
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    },
    start_time: function start_time() {
      return this.datenum[0] ? this.formatDate(this.datenum[0]) : '';
    },
    end_time: function end_time() {
      return this.datenum[1] ? this.formatDate(this.datenum[1]) : '';
    }
  }),
  methods: {
    setSycn: function setSycn(order, type) {
      var _this = this;
      if (order.is_unsign == 1) {
        if (type == 1 && order.is_cancel == 0) {
          this.$message({
            message: '订单解约前请先关闭订单',
            type: 'warning'
          });
        } else {
          (0, _request.default)({
            url: "/system/order/setSycn/",
            method: 'post',
            data: {
              order_id: order.id,
              type: type,
              shop: this.$user.data.shop
            }
          }).then(function (response) {
            if (response.code == 200) {
              _this.goSearch();
            } else {
              _this.$message({
                message: response.msg,
                type: 'warning'
              });
            }
            // this.listLoading = false
          }).catch(function (error) {
            // this.listLoading = false
          });
        }
      } else {
        this.$message({
          message: '订单用户未申请解约',
          type: 'warning'
        });
      }
    },
    // 格式化日期,需要加上时分秒的数据
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    getDateFiveDaysAgo: function getDateFiveDaysAgo(days) {
      var today = new Date(); // 获取当前日期
      today.setDate(today.getDate() - days); // 计算五日前的日期

      // 格式化日期为 YYYY-MM-DD
      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
      var day = String(today.getDate()).padStart(2, '0');
      if (days == 8) {
        return "".concat(year, "-").concat(month, "-").concat(day) + '前';
      }
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    // 查看订单详情
    handleClick: function handleClick(item) {
      //   this.$router.push({ name: 'orderDetail', query: { id: item.id } })
      this.$router.push({
        name: 'orderDetail',
        query: {
          type: 'orderList',
          id: item.id,
          page: this.listQuery.page
        }
      });
    },
    // 过滤租赁合同签署状态
    filterEsign: function filterEsign(value, row) {
      return row.is_esign_contract == value;
    },
    // 过滤代扣协议签署状态
    filterAlipay: function filterAlipay(value, row) {
      return row.is_alipay_contract == value;
    },
    // 过滤订单状态
    filterStatus: function filterStatus(value, row) {
      return row.is_cancel == value;
    },
    // 搜索方法——根据关键字搜索
    goSearch: function goSearch() {
      var _this2 = this;
      this.listLoading = true;
      // 发请求提交数据给后台
      (0, _request.default)({
        url: "/system/order/getList/",
        method: 'post',
        data: {
          alipay_id: this.formInline.alipay_id,
          userphone: this.formInline.userphone,
          orderNo: this.formInline.orderNo,
          username: this.formInline.username,
          start_time: this.start_time,
          end_time: this.end_time,
          g_date: this.formInline.g_date,
          status: this.formInline.status,
          three_order: this.formInline.three_order,
          is_jd: this.formInline.is_jd,
          shop: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          _this2.dataList = response.data.data;
        }
        _this2.listLoading = false;
      }).catch(function (error) {
        _this2.listLoading = false;
      });
    },
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this3 = this;
      this.listLoading = true;

      // 发请求提交数据给后台
      (0, _request.default)({
        url: "/system/order/getList/",
        method: 'post',
        data: {
          alipay_id: this.formInline.alipay_id,
          userphone: this.formInline.userphone,
          orderNo: this.formInline.orderNo,
          username: this.formInline.username,
          start_time: this.start_time,
          end_time: this.end_time,
          shop: this.$user.data.shop,
          g_date: this.formInline.g_date,
          status: this.formInline.status,
          is_jd: this.formInline.is_jd,
          page: this.listQuery.page,
          page_size: this.listQuery.page_size
        }
      }).then(function (response) {
        if (response.data) {
          _this3.dataList = response.data.data;
        }
        _this3.listLoading = false;
      }).catch(function (error) {
        _this3.listLoading = false;
      });
    },
    // 重置
    resetForm: function resetForm() {
      this.formInline.alipay_id = '';
      this.formInline.userphone = '';
      this.formInline.orderNo = '';
      this.formInline.username = '';
      this.formInline.start_time = '';
      this.formInline.end_time = '';
      this.datenum = [];
      this.formInline.three_order = '';
      this.formInline.status = '0';
      this.formInline.is_jd = -1;
      this.complain_picture = [];
      this.complain_text = '';
      this.complain_order_id = 0;
      this.getOrderList();
    },
    // 查看分期计划
    handleList: function handleList(data) {
      console.log(data);
      this.$router.push({
        name: 'periodList',
        query: {
          pk: data.id
        }
      });
    },
    show_complain: function show_complain(e) {
      this.action = "".concat(process.env.VUE_APP_BASE_API, "/safe/posts/");
      this.complain_order_id = e.id;
      this.is_show_complain = true;
      // console.log(e.id)
    },
    onSubmitAccount: function onSubmitAccount() {
      var _this4 = this;
      this.$confirm('确认提交投诉信息', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(function () {
        // this.loading = true

        (0, _request.default)({
          url: '/system/order/submitComplain/',
          method: 'post',
          data: {
            complain_picture: _this4.complain_picture,
            complain_text: _this4.complain_text,
            order_id: _this4.complain_order_id
          }
        }).then(function (response) {
          _this4.is_show_complain = false;
          _this4.complain_picture = [];
          _this4.complain_text = '';
          _this4.complain_order_id = 0;
        }).catch(function () {
          _this4.is_show_complain = false;
        });
      });
    }
  }
};